import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { API } from '@/lib/api';

const VISITOR_KEY = 'cfsc_visitor_id';

/**
 * Get or create a persistent visitor id stored in localStorage.
 */
function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random().toString(36).slice(2);
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return 'anonymous';
  }
}

/**
 * Fires a pageview tracking call on each route change.
 * Skips admin routes and ignores errors silently.
 */
export const PageviewTracker = () => {
  const location = useLocation();
  const lastSent = useRef(null);

  useEffect(() => {
    const path = location.pathname + location.search;
    // Don't track admin routes
    if (path.startsWith('/admin')) return;
    // Avoid duplicate fires on same path
    if (lastSent.current === path) return;
    lastSent.current = path;

    const visitor_id = getVisitorId();
    const referrer = document.referrer || null;

    // Best-effort tracking (no await, don't block rendering)
    axios
      .post(
        `${API}/analytics/pageview`,
        { path, referrer, visitor_id },
        { withCredentials: false }, // no cookies needed for public tracking
      )
      .catch(() => {
        /* silent */
      });
  }, [location.pathname, location.search]);

  return null;
};
